import { params, const_var} from '../redux/reducers/reducer';
import axios from 'axios';
import {getBuildingData, showDownloadProgressBar, showSaveLater, showSaveThank} from "./index";
 
 export function handleSaveLatter (value,key){
    console.log(value,key,"value,key")
    const_var.displayerrorMessage = {}
    return(dispatch)=>{
        dispatch({
            type: "handleSaveLatter",
            payload: value,
            key:key,
        })
    }
   
  }
  export function handleSavePublicQuote(value)
  {
    return(dispatch)=>{
        dispatch({
            type: "handleSavePublicQuote",
            payload:value
        })
    }
  }
  export function SendBuildingDatatoPublicServer()
  { 
    return(dispatch) => {
        
            if(const_var.post_data['building'].leanto!=undefined && const_var.post_data['building'].leanto.length>0)
            {
                for(var i=0;i<=const_var.post_data['building'].leanto.length-1;i++)
                {
                    if(const_var.post_data['building'].leanto[i].leanto_type==1)
                    {
                        const_var.post_data['building'].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentLeft];
                    }
                    if(const_var.post_data['building'].leanto[i].leanto_type==2)
                    {
                        const_var.post_data['building'].leanto[i].alignment = const_var.TypeAlingnment[params.leantoAlignmentRight];
                    }
                    if(const_var.post_data['building'].leanto[i].leanto_type==3)
                    {
                        const_var.post_data['building'].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentFront];
                    }
                    if(const_var.post_data['building'].leanto[i].leanto_type==4)
                    {
                        const_var.post_data['building'].leanto[i].alignment = const_var.endLeanAlingnmentType[params.leantoAlignmentBack];
                    }
                }
            }
            if (const_var.post_data.building != undefined && const_var.post_data['building'].other_building_type_name=='') {
                params.other_building_type_name = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h
                const_var.post_data['building'].other_building_type_name = params.other_building_type_name;
                const_var.post_data['building'].name = params.other_building_type_name;
            }
            const_var.post_data["building"].building_type_name = const_var.post_data["building"].other_building_type_name;
            const_var.post_data['name'] = const_var.post_data["building"].other_building_type_name;
            if(const_var.post_data["building"].left_wall_cutpanel==true)
            {
                const_var.post_data["building"].left_wall_price = parseFloat(const_var.post_data["building"].left_wall_price) + parseFloat(const_var.post_data["building"].left_wall_cut_panel_price);
            }if(const_var.post_data["building"].right_wall_cutpanel==true)
            {
                const_var.post_data["building"].right_wall_price = parseFloat(const_var.post_data["building"].right_wall_price) + parseFloat(const_var.post_data["building"].right_wall_cut_panel_price);
            }
            if(const_var.post_data["building"].surcharge_amount!=0)
            {
                const_var.post_data["building"].surcharge_taxable = (const_var.post_data["building"].surcharge_taxable==undefined)?0:const_var.post_data["building"].surcharge_taxable;
            }
            if(const_var.dealer_discount_label != undefined && const_var.dealer_discount_label != "") {
                const_var.post_data["building"].dealer_discount_label = const_var.dealer_discount_label  ;
            }
            if(const_var.manufacturer_discount_label != undefined && const_var.manufacturer_discount_label != "" && parseFloat(const_var.post_data["building"].discount_amount)>0){
                const_var.post_data["building"].manufacturer_discount_label = const_var.manufacturer_discount_label ;
            }
            const_var.post_data["building"].old_permit_Fee = const_var.exact_order_permit_fee
            const_var.post_data["building"].is_showBackgroundImage = const_var.crmSetting.is_show_background;
            const_var.post_data['building'].custom_distance_on_center = (params.oncenter_val_with_action!='')?params.oncenter_val_with_action:'';
            const_var.post_data["building"].custom_building = (const_var.b_o_J_1[params.p_b_t]=="Custom Buildings")?1:const_var.hide_price_calculation;
            const_var.post_data["building"].payment_mode = const_var.paymentOptionObj[params.paymentmode];
            const_var.post_data["user_id"] = const_var.crmSetting.login_user_id;
            const_var.post_data['is_quote'] = 1;
            const_var.post_data['questions'] = const_var.estimator_QuestionAnswer;
            const_var.post_data['charge_card'] = 0;
            const_var.post_data['form_type'] = "3d_v3";
            const_var.post_data['created_source'] = "3d_v3";
            const_var.post_data['is_api'] = 1;
            const_var.post_data['referral_source'] = const_var.referrer;
            const_var.post_data['page'] = const_var.crmSetting.page;
            const_var.post_data['form'] = "Quote Form";
            const_var.post_data['api_token'] = const_var.crmSetting.api_token;
            const_var.post_data['building_update'] = true;
            const_var.post_data['pdf_price_breakdown'] = const_var.order_extra_items['pdf_price_breakdown'];
            const_var.post_data = {...const_var.post_data,...const_var.LeadCustomerData};
            if(const_var.post_data['mobile_no']==undefined)
            {
                const_var.post_data['mobile_no'] = const_var.post_data['phone_no'];
            }
            //const_var.post_data['twoDImageObj'] = const_var.twoDImageObj;
            const_var.post_data['source'] =  const_var.crmSetting.source; 
            const_var.post_data['billing_county'] = const_var.post_data.billing_country;
            const_var.post_data['shipping_county'] = const_var.post_data.shipping_country;
            const_var.post_data['module'] = const_var.crmSetting.is_module_name;
            const_var.post_data["module_id"] = const_var.crmSetting.is_module_id;
            const_var.post_data["sub_module"] = const_var.crmSetting.sub_module;
            const_var.post_data["sub_module_id"] = const_var.crmSetting.sub_module_id;
            const_var.post_data["building_data"] = const_var.SendAPIBuildingData;
            const_var.post_data['estimator_domain'] = const_var.crmSetting.main_domain_url;
            const_var.post_data["pricing_data"] = const_var.a_p_d_a;
        return axios.post(const_var.crmSetting.api_post_url+'/api/v1/'+const_var.crmSetting.is_Action_url,const_var.post_data).then(function(response){
                    const_var.post_data["module_id"] = response.data.id;
                    if(response.data.status==true)
                    {
                        const_var.isPublicEdit = false;
                    }
                    dispatch({
                        type:"onQuoteSubmitApi",
                        event : response.data
                    });
                //window.location.href = const_var.crmSetting.source+"/"+const_var.crmSetting.is_module_name+'s/'+response.id;
                
            })
            .catch(function(error){
                console.log(error);
            })
        }
  }
  export function onquoteTextFiledChangeValue (e,name,keyword,flag,updateVar = false){ 
  
    return(dispatch)=>{
        dispatch({
            type: "onquoteTextFiledChangeValue",
            event:e,
            value:name,
            keyword:keyword,
            flagg:flag,
            updateVar:updateVar
        })
    }
  }

export function onSubmit (e,isCreateFeed = false,callApiOnly = false){ 
    return(dispatch)=>{ 
        if(callApiOnly == true) {
            dispatch(onQuoteSubmitApi());
        }
        else{
            dispatch({
                type: "onQuoteSubmit",
                event: e
            });
            dispatch(inputValidate(e))
            if(const_var.checkValidate==false){
                const_var.is_loader = true
                const_var.showReportLoading = true;

                if(const_var.post_data.full_name != undefined && const_var.post_data.full_name != ''){
                    let fullname = const_var.post_data.full_name
                    let separation = fullname.split(" ")
                    let fname = separation[0]
                    let lname = separation[1] ? fullname.substr(fullname.indexOf(' ') + 1) : '';
    
                    const_var.post_data['first_name']=fname
                    const_var.post_data['last_name']=lname
                }

                if(isCreateFeed==true && (const_var.ziperrormsg == '' || const_var.ziperrormsg == undefined)){        
                    const formData = new FormData();
                    formData.append('first_name', const_var.post_data.first_name);
                    formData.append('last_name', const_var.post_data.last_name);
                    formData.append('email', const_var.post_data.email);
                    formData.append('phone_no', const_var.post_data.phone_no);
                    formData.append('zipcode', const_var.post_data.address[0].zipcode);
                    formData.append('address', const_var.post_data.address[0].address_line_1);
                    formData.append('api_token', const_var.crmSetting.api_token)
                    formData.append('form', const_var.crmSetting.form);
                    formData.append('source', const_var.crmSetting.source);
                    formData.append('page', const_var.crmSetting.page);
                    formData.append('lead_source', '3D Estimator');
                    return axios.post(const_var.crmSetting.api_post_url + '/api/v1/create-lead', formData, {headers: {        
                            'content-type': 'multipart/form-data'
                        }
                    }).then(function(response){
                        if(response.data.status == true){
                            // getBuildingData()
                            const_var.preQuoteApiCalled = true
                            const_var.preQuoteError = false
                        }
                        else{
                            const_var.preQuoteApiCalled = true
                            const_var.preQuoteError = true
                        }
                        const_var.showReportLoading = false
                        return true
                    })
                    .catch(function(error){
                        const_var.preQuoteApiCalled = true
                        const_var.preQuoteError = true
                        const_var.showReportLoading = false
                        return false
                    })                  
                    
                }
                if(isCreateFeed == false){
                    dispatch(onQuoteSubmitApi(e));
                }
            }
        }
    }
}

export function onQuoteSubmitApi(e)
{   
    if(const_var.dealer_discount_label != undefined && const_var.dealer_discount_label != "") {
        const_var.post_data["building"].dealer_discount_label = const_var.dealer_discount_label  ;
    }
    if(const_var.manufacturer_discount_label != undefined && const_var.manufacturer_discount_label != "" && parseFloat(const_var.post_data["building"].discount_amount)>0){
        const_var.post_data["building"].manufacturer_discount_label = const_var.manufacturer_discount_label ;
    }
    const_var.post_data["building"].selectedBuildingUniqId = const_var.selectedBuildingUniqId;
    if(const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data!=undefined && const_var.editAPIDataByResponse!=undefined && const_var.editAPIDataByResponse.data.main_created_at !=undefined){
        
        const_var.post_data["building"].create_at_date= const_var.editAPIDataByResponse.data.request_data != undefined && const_var.editAPIDataByResponse.data.request_data.building  != undefined && const_var.editAPIDataByResponse.data.request_data.building.create_at_date != undefined ? const_var.editAPIDataByResponse.data.request_data.building.create_at_date : const_var.editAPIDataByResponse.data.main_created_at 

        const_var.post_data.main_created_at= const_var.editAPIDataByResponse.data.main_created_at 
    }
    
    const_var.post_data["is_generate_pdf"]=true;
    if(params.p_c_i && const_var.post_data && const_var.post_data.building){
        const_var.post_data.building.insulation = 'custom'
    }
    
    if((params.p_r_o || params.p_f_i) && const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0){
        const updatedLeandata = const_var.post_data.building.leanto.map(({insulation_type,insulation_price,...rest}) => ({...rest}));
        const_var.post_data.building.leanto = updatedLeandata
        const_var.post_data.building.leanto.insulation = ''
        // console.log(updatedLeandata);
    }
//    return(dispatch) => {
//     if(const_var.crmSetting.main_domain_url == "keensbuildings.com"){    
//         return axios.post(const_var.crmSetting.api_post_url+'/api/v1/order/save',const_var.post_data).then(async(response) => {
//                 const URL = "https://hooks.zapier.com/hooks/catch/16508503/2tlkngj/";
//                 let sub_order_total_keen = const_var.BuildingPriceArrar["sub_order_total"] !== undefined ? const_var.BuildingPriceArrar["sub_order_total"] : 0;
//                 let payload = {
//                     "first_name": const_var.post_data.first_name,
//                     "last_name": const_var.post_data.last_name,
//                     "email": const_var.post_data.email,
//                     "phone": const_var.post_data.phone_no,
//                     "installation_zip": const_var.post_data.address[0].zipcode,
//                     "deal_name": `${const_var.post_data.building.length}X${const_var.post_data.building.width}X${const_var.post_data.building.height} ${const_var.post_data.building.building_type_name} ${response.data.quote_string}`,
//                     "product_type" : "Metal Building/Carport",
//                     "building_type": const_var.post_data.building.building_type_name,
//                     "building_width": const_var.post_data.building.width,
//                     "building_length": const_var.post_data.building.length,
//                     "building_height": const_var.post_data.building.height,
//                     "framing_gauge": `${const_var.post_data.building.gauge} Gauge`,
//                     "building_certification": const_var.post_data.building.certificate_name,
//                     "building_manufacture": const_var.post_data.building.manufacturer_name,
//                     "installation_surface": const_var.post_data.building.installation_surface,
//                     "roof_style": const_var.post_data.building.roof_style_name,
//                     "roof_pitch": const_var.post_data.building.roof_pitch,
//                     "roof_color": const_var.post_data.building.roof_color.name,
//                     "trim_color": const_var.post_data.building.trim_color.name,
//                     "wall_color": const_var.post_data.building.wall_color.name,
//                     "wainscot_color": const_var.post_data.building.wainscot !== undefined ? const_var.post_data.building.wainscot.name : "",
//                     "components": "",
//                     "building_quote": response.data.pdf_url,
//                     "building_msrp": 0,
//                     "manufacturer_discount": const_var.post_data['building'].discount_amount,
//                     "subtotal": sub_order_total_keen,
//                     "quote_id": response.data.quote_string,
//                     "deal_id": response.data.quote_string,
//                     "questions": const_var.post_data.questions,
//                 };
//                 try {
//                     const res = await fetch(URL, {
//                         method: "POST",
//                         headers: {'Content-Type': 'application/json'},
//                         body: JSON.stringify(payload),
//                         mode: "no-cors"
//                     });

//                     if (!res.ok) {
//                         throw new Error('Network res was not ok');
//                     }
//                     const resp = await res.json();
//                     console.log(resp);
//                 } catch (error) {
//                     console.log('There was a problem with the fetch operation:', error);
//                 }
//                 dispatch({
//                     type:"onQuoteSubmitApi",
//                     event : response.data
//                 });       
//             })
//             .catch(function(error){
//                 console.log(error);
//             })
//         }else{
            
//             if(params.p_c_i && const_var.post_data && const_var.post_data.building){
//                 const_var.post_data.building.insulation = 'custom'  
//             }
            
//             // if((params.p_r_o || params.p_f_i) && const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0){
//             //     const updatedLeandata = const_var.post_data.building.leanto.map(({insulation_type,insulation_price,...rest}) => ({...rest}));
//             //     const_var.post_data.building.leanto = updatedLeandata
//             //     const_var.post_data.building.leanto.insulation = ''
//             //     // console.log(updatedLeandata);
//             // }
//             return axios.post(const_var.crmSetting.api_post_url+'/api/v1/order/save',const_var.post_data).then(function(response){
//                 dispatch({
//                     type:"onQuoteSubmitApi",
//                     event : response.data
//                 });            
//             })
//             .catch(function(error){
//                 console.log(error);
//             })
//         }
    let clonePostData = JSON.parse(JSON.stringify(const_var.post_data))
    let building_data = clonePostData.building && Object.entries(clonePostData.building)
    if(building_data.length > 0 && const_var.isShowSaveQuote == true){
        building_data.map(([item, value]) => {
            if(typeof(value) == "object"){
                let value_data = value && Object.entries(value)
                if(value_data != undefined && value_data.length > 0){
                    value_data.map(([innerItem, value]) => {
                        if(innerItem.includes("price") || innerItem.includes("cost") || innerItem.includes("total") || innerItem.includes("fee") || innerItem.includes("deposit") || innerItem.includes("amount") || innerItem.includes("rate")){
                            clonePostData.building[item][innerItem] = 0
                        }    
                    })
                }
            }else{
                if(item.includes("price") || item.includes("total") || item.includes("cost") || item.includes("fee") || item.includes("deposit") || item.includes("amount") || item.includes("rate")){
                    clonePostData.building[item] = 0
                }
            }
        })

        if(clonePostData.building.entry_points !== undefined && clonePostData.building.entry_points.length > 0){
            clonePostData.building.entry_points.map((entryPoint,index) => {
                let abc = Object.entries(entryPoint)
                abc.map(([item, value]) => {
                    if(typeof(value) == "object"){
                        let value_data = value && Object.entries(value)
                        if(value_data != undefined && value_data.length > 0){
                            value_data.map(([innerItem, value]) => {
                                if(innerItem.includes("price") || innerItem.includes("cost") || innerItem.includes("total") || innerItem.includes("fee") || innerItem.includes("deposit") || innerItem.includes("amount") || innerItem.includes("rate")){
                                    clonePostData.building.entry_points[index][item][innerItem] = 0
                                }    
                            })
                        }
                    }else{
                        if(item.includes("price") || item.includes("total") || item.includes("cost") || item.includes("fee") || item.includes("deposit") || item.includes("amount") || item.includes("rate")){
                            clonePostData.building.entry_points[index][item] = 0
                        }
                    }
                })
            })    
        }

        if(clonePostData.building.extra_items !== undefined && clonePostData.building.extra_items.length > 0){
            clonePostData.building.extra_items.map((extraItems,index) => {
                let abc = Object.entries(extraItems)
                abc.map(([item, value]) => {
                    if(typeof(value) == "object"){
                        let value_data = value && Object.entries(value)
                        if(value_data != undefined && value_data.length > 0){
                            value_data.map(([innerItem, value]) => {
                                if(innerItem.includes("price") || innerItem.includes("cost") || innerItem.includes("total") || innerItem.includes("fee") || innerItem.includes("deposit") || innerItem.includes("amount") || innerItem.includes("rate")){
                                    clonePostData.building.extra_items[index][item][innerItem] = 0
                                }    
                            })
                        }
                    }else{
                        if(item.includes("price") || item.includes("total") || item.includes("cost") || item.includes("fee") || item.includes("deposit") || item.includes("amount") || item.includes("rate")){
                            clonePostData.building.extra_items[index][item] = 0
                        }
                    }
                })
                clonePostData.building.extra_items[index].is_edit = true
            })    
        }

        if(clonePostData.building.leanto !== undefined && clonePostData.building.leanto.length > 0){
            clonePostData.building.leanto.map((extraItems,index) => {
                let abc = Object.entries(extraItems)
                abc.map(([item, value]) => {
                    if(typeof(value) == "object"){
                        let value_data = value && Object.entries(value)
                        if(value_data != undefined && value_data.length > 0){
                            value_data.map(([innerItem, value]) => {
                                if(innerItem.includes("price") || innerItem.includes("cost") || innerItem.includes("total") || innerItem.includes("fee") || innerItem.includes("deposit") || innerItem.includes("amount") || innerItem.includes("rate")){
                                    clonePostData.building.leanto[index][item][innerItem] = 0
                                }    
                            })
                        }
                    }else{
                        if(item.includes("price") || item.includes("total") || item.includes("cost") || item.includes("fee") || item.includes("deposit") || item.includes("amount") || item.includes("rate")){
                            clonePostData.building.leanto[index][item] = 0
                        }
                    }
                })
            })    
        }

        if(clonePostData.building.cupola_obj !== undefined && clonePostData.building.cupola_obj.length > 0){
            clonePostData.building.cupola_obj.map((extraItems,index) => {
                let abc = Object.entries(extraItems)
                abc.map(([item, value]) => {
                    if(typeof(value) == "object"){
                        let value_data = value && Object.entries(value)
                        if(value_data != undefined && value_data.length > 0){
                            value_data.map(([innerItem, value]) => {
                                if(innerItem.includes("price") || innerItem.includes("cost") || innerItem.includes("total") || innerItem.includes("fee") || innerItem.includes("deposit") || innerItem.includes("amount") || innerItem.includes("rate")){
                                    clonePostData.building.cupola_obj[index][item][innerItem] = 0
                                }    
                            })
                        }
                    }else{
                        if(item.includes("price") || item.includes("total") || item.includes("cost") || item.includes("fee") || item.includes("deposit") || item.includes("amount") || item.includes("rate")){
                            clonePostData.building.cupola_obj[index][item] = 0
                        }
                    }
                })
            })    
        }

        if(clonePostData.building.cupolaEntries !== undefined && clonePostData.building.cupolaEntries.length > 0){
            clonePostData.building.cupolaEntries.map((extraItems,index) => {
                let abc = Object.entries(extraItems)
                abc.map(([item, value]) => {
                    if(typeof(value) == "object"){
                        let value_data = value && Object.entries(value)
                        if(value_data != undefined && value_data.length > 0){
                            value_data.map(([innerItem, value]) => {
                                if(innerItem.includes("price") || innerItem.includes("cost") || innerItem.includes("total") || innerItem.includes("fee") || innerItem.includes("deposit") || innerItem.includes("amount") || innerItem.includes("rate")){
                                    clonePostData.building.cupolaEntries[index][item][innerItem] = 0
                                }    
                            })
                        }
                    }else{
                        if(item.includes("price") || item.includes("total") || item.includes("cost") || item.includes("fee") || item.includes("deposit") || item.includes("amount") || item.includes("rate")){
                            clonePostData.building.cupolaEntries[index][item] = 0
                        }
                    }
                })
            })    
        }

        if(clonePostData.building.ExtraItemsFeaturesArray !== undefined && clonePostData.building.ExtraItemsFeaturesArray.length > 0){
            clonePostData.building.ExtraItemsFeaturesArray.map((extraItems,index) => {
                let abc = Object.entries(extraItems)
                abc.map(([item, value]) => {
                    if(typeof(value) == "object"){
                        let value_data = value && Object.entries(value)
                        if(value_data != undefined && value_data.length > 0){
                            value_data.map(([innerItem, value]) => {
                                if(innerItem.includes("price") || innerItem.includes("cost") || innerItem.includes("total") || innerItem.includes("fee") || innerItem.includes("deposit") || innerItem.includes("amount") || innerItem.includes("rate")){
                                    clonePostData.building.ExtraItemsFeaturesArray[index][item][innerItem] = 0
                                }    
                            })
                        }
                    }else{
                        if(item.includes("price") || item.includes("total") || item.includes("cost") || item.includes("fee") || item.includes("deposit") || item.includes("amount") || item.includes("rate")){
                            clonePostData.building.ExtraItemsFeaturesArray[index][item] = 0
                        }
                    }
                })
                clonePostData.building.ExtraItemsFeaturesArray[index].is_edit = true
            })    
        }

        clonePostData.building_total = 0
        clonePostData.building.hide_price_calculation = 1
        clonePostData.building.due_upon_installation = 0
        clonePostData.building.extra_labour = "0"
        clonePostData.building.order_extra_items.extra_labour = "0"
        clonePostData.building.old_permit_Fee = "0"
        clonePostData.building.engineer_drawings = "0"
    }
    
    if(const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen  == true){
        const_var.post_data["building"].state_mfg_zipcode = const_var.state_mfg_zipcode
    }
    const_var.post_data["building"].old_permit_Fee = const_var.exact_order_permit_fee
   
    let holdData = const_var.isShowSaveQuote == true ? clonePostData : const_var.post_data
    return(dispatch) => {
        return axios.post(const_var.crmSetting.api_post_url+'/api/v1/order/save',holdData).then(function(response){
            dispatch({
                type:"onQuoteSubmitApi",
                event : response.data
            }); 
            // dispatch(showSaveLater("form",false))
            document.querySelector('#saveForm').classList.remove('overlay-container' , 'gather-customer-information')
            document.querySelector('#saveForm').classList.add('d-none')
            const_var.is_loader = false
            dispatch(showSaveThank())
            const_var.post_data.first_name = "";
            const_var.post_data.phone_no = "" ;
            const_var.post_data.email = "";  
            const_var.post_data.messageField = '';   
            const_var.displayerrorMessage = {}
        })
        .catch(function(error){
            console.log(error);
        })
    }
   
}
export function onLeadSubmitApi(e)
{
   return(dispatch) => {
    dispatch(inputValidate(e))
    console.log(const_var.checkValidate,"const_var.checkValidate")
            if (const_var.checkValidate === false) {
                const_var.is_loader = true
                if(!const_var.isShowDownloadProgressBar) {
                    dispatch(showDownloadProgressBar("show"))
                }
              setTimeout(async () => {
                console.log(const_var.pdfBlob,"const_var.pdfBlob")
                const formData = new FormData();
                formData.append('first_name', const_var.post_data.first_name);
                formData.append('last_name', const_var.post_data.last_name);
                formData.append('email', const_var.post_data.email);
                formData.append('phone_no', const_var.post_data.phone_no);
                // formData.append('zipcode', const_var.post_data.address[0].zipcode);
                // formData.append('address', const_var.post_data.address[0].address_line_1);
                formData.append('api_token', const_var.crmSetting.api_token)
                formData.append('form', const_var.crmSetting.form);
                formData.append('source', const_var.crmSetting.source);
                formData.append('page', const_var.crmSetting.page);
                formData.append('lead_source', '3D Estimator');
                formData.append('attachments[]', const_var.pdfBlob);
                return axios.post(const_var.crmSetting.api_post_url + '/api/v1/create-lead', formData, {headers: {        
                        'content-type': 'multipart/form-data'
                    }
                }).then(function(response){
                    if(response.data.status == true){
                
                    dispatch({
                        type:"onQuoteSubmitApi",
                        event : response.data
                    }); 
                    // dispatch(showSaveLater("form",false))  
                    document.querySelector('#saveForm').classList.remove('overlay-container' , 'gather-customer-information')
                    document.querySelector('#saveForm').classList.add('d-none')
                    const_var.is_loader = false
                    dispatch(showSaveThank("show"))
                    const_var.post_data.first_name = "";
                    const_var.post_data.phone_no = "" ;
                    const_var.post_data.email = "";
                    const_var.post_data.messageField = '';        
                    const_var.displayerrorMessage = {};
                    const_var.i_g_A_y = []
                    const_var.checkIval = 0;
                    const_var.isShowDownloadProgressBar = undefined
                } 
                })
                .catch(function(error){
                    console.log(error);
                });               
             },3100);
            }
    }
   
}
export function setThankYouForSaveLaterValue(val)
{
    
   return(dispatch) => {
            dispatch({
                type:"setThankYouForSaveLaterValue",
                val : val
            });   
    }
   
}
export function inputValidate(e) {
    return (dispatch) => {
        dispatch({
            type: "inputValidate",
            event: e
        })
    }
}

export function inputFieldChangeValue (e , name , keyword , flag , ValidationCheck , editEmail  ) {
    return(dispatch)=>{
        dispatch({
            type: "INPUTFIELDCHANGEVALUE",
            event:e,
            value:name,
            keyword:keyword,
            flagg:flag,
            ValidationCheck: ValidationCheck,
            editEmail: editEmail
        })
    }
}

export function keenBuildingRTO(val){   
    return(dispatch) => {
             dispatch({
                 type:"keenBuildingRTO",
                 val : val
             });   
     }
    
 }
